<template>
  <div class="d-flex flex-column justify-space-between" style="height: 100%; ">
    <div>
      <p class="caption lightgray--text">Thiết Lập Đơn</p>
      <v-checkbox v-model="state" label="Đánh dấu đơn hàng là Đã Duyệt"></v-checkbox>
      <p class="caption lightgray--text">Thiết Lập Lớp Học</p>
      <autocomplete-class
        v-model="selected"
        item-text="name"
        item-value="id"
        :filter="{status_in: ['opened', 'running']}"
        label="Lớp"
        placeholder="Chọn Lớp Học"
        required
        dense
        multiple
        outlined
      ></autocomplete-class>
    </div>
    <div class="d-flex justify-space-between">
      <v-spacer />
      <v-btn
        color="primary"
        @click="save()"
        :loading="loading"
        depressed
        small
      >Lưu Lại</v-btn>
    </div>
  </div>
</template>
<script>
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import { Student } from '@/plugins/api'
import { mapActions } from 'vuex'
export default {
  components: { AutocompleteClass },
  props: {
    student: Object,
    lead: Object
  },
  data () {
    return {
      selected: [],
      loading: false,
      state: true
    }
  },
  methods: {
    ...mapActions('leads', ['updateLead']),
    async save () {
      this.loading = true
      if (this.selected.length) {
        await Student.update(this.student.id, {
          classes: [
            ...this.student.classes.map(c => c.id),
            ...this.selected.map(m => m.id)
          ]
        })
      }
      await this.updateLead({ id: this.lead.id,
        state: this.state ? 'approved' : 'under-approval'
      })
      this.$alert.success('Cập nhật thông tin thành công')
      this.loading = false
      this.$emit('complete')
    }
  },
  computed: {},
  filters: {},
  watch: {
    student () {
      this.selected = []
    }
  }
}
</script>
<style scoped>
.bottom {
  align-self: flex-end;
}
</style>
